import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ctoken');
    const saved = localStorage.getItem('cuser');
    if (token && saved) {
      setUser(JSON.parse(saved));
      authAPI.me().then(res => {
        setUser(res.data);
        localStorage.setItem('cuser', JSON.stringify(res.data));
      }).catch((e) => {
        // Only a rejected login logs the user out; a network hiccup keeps them in.
        if (e.response?.status === 401) {
          localStorage.removeItem('ctoken');
          localStorage.removeItem('cuser');
          setUser(null);
        }
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    const { access_token, user: u } = res.data;
    localStorage.setItem('ctoken', access_token);
    localStorage.setItem('cuser', JSON.stringify(u));
    setUser(u);
    return u;
  };

  const register = async (email, password, first_name, last_name, id_number, phone) => {
    const res = await authAPI.register({ email, password, first_name, last_name, id_number, phone });
    const { access_token, user: u } = res.data;
    localStorage.setItem('ctoken', access_token);
    localStorage.setItem('cuser', JSON.stringify(u));
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('ctoken');
    localStorage.removeItem('cuser');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

